// Identifies a user in the Attribution App
export function identifyAttributionUser({ first_name, last_name, email }) {
    const isBrowser = typeof window !== 'undefined';

    if (isBrowser && window.Attribution) {
        window.Attribution.identify({
            name: `${first_name} ${last_name}`,
            email,
        });
    }
}
